const colorTypeHelper = {
  Transparent: 'var(--transparent)',
  Black: 'var(--neutral-7)',
  'Blue 1': 'var(--blue-1)',
  'Blue 3': 'var(--blue-3)',
  'Blue 5 (Primary)': 'var(--blue-5)',
  'Blue 6': 'var(--blue-6)',
  'Blue 7': 'var(--blue-7)',
  'Green 5 (Primary)': 'var(--green-5)',
  'Green 6': 'var(--green-6)',
  'Green 7': 'var(--green-7)',
  'Navy 5 (Primary)': 'var(--navy-5)',
  'Navy 6': 'var(--navy-6)',
  'Navy 7': 'var(--navy-7)',
  'Neutral 1': 'var(--neutral-1)',
  'Neutral 2': 'var(--neutral-2)',
  'Neutral 4': 'var(--neutral-4)',
  'Neutral 5 (Primary)': 'var(--neutral-5)',
  'Neutral 6': 'var(--neutral-6)',
  'Neutral 7': 'var(--neutral-7)',
  'Orange 5 (Primary)': 'var(--orange-5)',
  'Orange 6': 'var(--orange-6)',
  'Orange 7': 'var(--orange-7)',
  Gray: 'var(--dark-gray-color)',
  Purple: 'var(--purple)',
  Red: 'var(--red)',
  'Teal 5 (Primary)': 'var(--teal-5)',
  'Teal 6': 'var(--teal-6)',
  'Teal 7': 'var(--teal-7)',
  White: 'var(--white)',
};

const getColor = color => {
  if (!color) return null;

  const colorKey = Object.keys(colorTypeHelper).find(key => {
    return key.toLowerCase().includes(color.toLowerCase()) && colorTypeHelper[key];
  });

  return colorTypeHelper[colorKey] || color;
};

export default getColor;
